export const DEFAULT_ACCEPT_FILES = {
  'image/gif': ['.gif'],
  'image/png': ['.png'],
  'image/heic': ['.heic'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'video/mp4': ['.mp4'],
  'video/mpeg': ['.mpeg'],
  'video/x-msvideo': ['.avi'],
  'video/x-ms-wmv': ['.wmv'],
  'video/x-flv': ['.flv'],
  'application/csv': ['.csv'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'text/plain': ['.txt'],
  'video/quicktime': ['.mov'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'application/vnd.ms-outlook': ['.msg'],
  'audio/mpeg': ['.mp3'],
};
